/**
 * useMeeting Hook
 *
 * Provider-agnostic hook that provides meeting state and functionality.
 * Uses the adapter pattern to work with either Dyte or LiveKit.
 *
 * Refactored to use the meeting adapter instead of direct Dyte hooks.
 */

import { useMeetingProviderAdapter } from 'adapters/getMeetingProvider';
import { WHITEBOARD_PLUGIN_ID } from 'configs';
import { useSearchParams } from 'react-router-dom';

const useMeeting = () => {
  const [searchParams] = useSearchParams();

  // Get the adapter (works with either Dyte or LiveKit)
  const adapter = useMeetingProviderAdapter();

  const classId = searchParams.get('classId') || '';

  // Get whiteboard plugin (if supported by provider)
  const whiteBoardPlugin = adapter.allPlugins.find(
    (p: unknown): boolean => {
      if (typeof p === 'object' && p !== null && 'id' in p) {
        const plugin = p as { id?: string };
        return plugin.id === WHITEBOARD_PLUGIN_ID;
      }
      return false;
    }
  );

  // Return the same interface as before, but now provider-agnostic
  return {
    self: adapter.self,
    screenShareHost: adapter.screenShareHost,
    screenShareEnabled: adapter.screenShareEnabled,
    activePlugins: adapter.activePlugins,
    socketUser: adapter.socketUser,
    classId,
    meeting: adapter.meeting,
    allPlugins: adapter.allPlugins,
    joinedParticipants: adapter.participants.toArray(),
    tutorId: adapter.tutorId,
    whiteBoardPlugin,
    tutors: adapter.tutors,
  };
};

export default useMeeting;
